/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Sidebar_NewInputs */



/**
* | output |
* | --- |
* | "New chat" |
*
* @param {Chat_Sidebar_NewInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_sidebar_new = /** @type {((inputs?: Chat_Sidebar_NewInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Sidebar_NewInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nieuwe chat")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau chat")
	return /** @type {LocalizedString} */ ("New chat")
});